import React from 'react'
import { useParams } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { Spinner } from '@web/walter-ui-kit'
import remarkGfm from 'remark-gfm'
import s from './s.module.css'
import { useGetAgreements } from '~api'

function AgreementPage() {
    const params = useParams()

    const { cardId, agreementId } = params || {}

    const { data, isLoading } = useGetAgreements(
        { productId: cardId || '', agreementId: agreementId || '' },
        { shouldRequest: !!cardId && !!agreementId }
    )

    if (isLoading) {
        return (
            <div className={s.spinner}>
                <Spinner intent="accent" size={36} />
            </div>
        )
    }

    return (
        <div className={s.wrap}>
            <div className={s.container}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{data?.content}</ReactMarkdown>
            </div>
        </div>
    )
}

export default AgreementPage
